/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeliveredShelfLifeItemModel { 
    itemNumber?: string | null;
    description?: string | null;
    uOfM?: string | null;
    alertQuantity?: number;
    alertAmount?: number;
    readonly alertTitle?: string | null;
    warningQuantity?: number;
    warningAmount?: number;
    readonly warningTitle?: string | null;
    safeQuantity?: number;
    safeAmount?: number;
    readonly safeTitle?: string | null;
    goodQuantity?: number;
    goodAmount?: number;
    readonly goodTitle?: string | null;
    hasExpirationDate?: boolean;
}

